/* V40 (8 okt 2026): popups voor gereserveerde en verkochte items. Zie snippets/hv-item-popup.liquid.
   V50 (24 okt 2026): huisstijl P1 en R2, zonder productregel; beide popups tonen drie vergelijkbare items.
   31 okt 2026: de korte melding onder de knop bij een verkocht item is weg (Jens: "Knop \"Sold\", melding weg").
   31 okt 2026: tegels zonder <img> (beeld als achtergrond), zodat de strook RESERVED van de reserveringsapp nooit op een
   tegel in de popup komt. */
(() => {
  const cfgEl = document.getElementById('hv-pop-config');
  if (!cfgEl || window.__hvItemPopup) return;
  window.__hvItemPopup = true;
  const C = JSON.parse(cfgEl.textContent);
  const L = C.labels;

  /* 31 okt 2026: teksten van de reserveringsapp (cart-hold) per taal uit het thema (L.hold, zie de snippet).
     Dit script (defer) staat in de pagina vóór het module-script van de app; beide wachten tot de pagina geparsed is en
     lopen dan in volgorde. De app leest zijn config dus pas na deze aanpassing. Alleen de labels veranderen; %TIME% blijft
     staan voor de app. Lukt het niet, dan toont de app zijn eigen tekst en werkt alles verder gewoon. */
  const holdEl = document.querySelector('script[data-hv-hold-config]');
  if (holdEl && L.hold && !window.__hvCartTimer) {
    try {
      const hc = JSON.parse(holdEl.textContent);
      const mins = String(hc.holdMinutes || 20);
      const own = {
        notify_title: L.reserved, notify_text: L.reserved_text, notify_placeholder: L.placeholder, notify_button: L.submit,
        notify_thanks: L.thanks, notify_error: L.error, notify_view: L.view, notify_close: L.close,
      };
      Object.keys(L.hold).forEach((k) => { own[k] = String(L.hold[k]).replace('%HOLD%', mins); });
      Object.keys(own).forEach((k) => { if (own[k] == null) delete own[k]; });
      hc.labels = Object.assign({}, hc.labels, own);
      holdEl.textContent = JSON.stringify(hc);
    } catch (e) { /* app-tekst blijft staan */ }
  }
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const html = document.documentElement;
  const coarse = window.matchMedia('(pointer: coarse)');
  const cache = new Map();
  let lastHandle = null;
  let sold = null;
  let soldInfo = null;

  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const handleFrom = (href) => {
    const m = /\/products\/([^/?#]+)/.exec(href || '');
    return m ? decodeURIComponent(m[1]) : null;
  };
  const getInfo = (handle) => {
    if (!handle) return Promise.resolve(null);
    if (!cache.has(handle)) {
      cache.set(handle, fetch(`${root}products/${encodeURIComponent(handle)}?view=hvpop`, { credentials: 'same-origin' })
        .then((r) => (r.ok ? r.json() : null))
        .catch(() => null));
    }
    return cache.get(handle);
  };
  const cardOf = (el) => el && el.closest && el.closest('product-card, .product-card');
  const cardHandle = (card) => {
    const a = card && card.querySelector('a[href*="/products/"]');
    return a ? handleFrom(a.getAttribute('href')) : null;
  };
  const isSoldCard = (card) => !!(card && card.querySelector('.product-badges__badge--sold-out'));

  const closeIcon = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M2 2l12 12M14 2L2 14"/></svg>';
  const similarHtml =
    '<div class="hv-pop__similar" hidden><div class="hv-pop__head">' +
    `<p class="hv-pop__h">${esc(L.similar)}</p><a class="hv-pop__all" hidden></a></div>` +
    '<div class="hv-pop__grid"></div></div>';
  const placeholderTiles = '<div class="hv-pop__tile hv-pop__tile--ph" aria-hidden="true"><div class="hv-pop__tile-img"></div><p class="hv-pop__tile-b"></p><p class="hv-pop__tile-t"></p></div>'.repeat(3);
  const tileHtml = (p) =>
    `<a class="hv-pop__tile" href="${esc(p.url)}">` +
    `<div class="hv-pop__tile-img"${p.image ? ` data-hv-bg="${esc(p.image)}"` : ''}></div>` +
    `<p class="hv-pop__tile-b">${esc(p.vendor)}</p><p class="hv-pop__tile-t">${esc(p.title)}</p><p class="hv-pop__tile-p">${esc(p.price)}</p></a>`;

  /* Vergelijkbare items (merk + type) en de link naar die collectie, voor verkocht en gereserveerd. */
  const loadSimilar = (box, handle) => {
    const all = box.querySelector('.hv-pop__all');
    const grid = box.querySelector('.hv-pop__grid');
    box.dataset.handle = handle || '';
    all.hidden = true;
    grid.innerHTML = placeholderTiles;
    grid.hidden = false;
    box.hidden = !handle;
    return getInfo(handle).then((info) => {
      if (box.dataset.handle !== (handle || '')) return null;
      const items = ((info && info.similar) || []).slice(0, 3);
      if (info && info.collection) {
        all.textContent = L.collection.replace('%TITLE%', info.collection.title);
        all.setAttribute('href', info.collection.url);
        all.hidden = false;
      }
      grid.innerHTML = items.map(tileHtml).join('');
      /* Beeld als achtergrond, niet als <img>. De reserveringsapp (markCards) zoekt bij elke link naar het gereserveerde item
         de eerste <img> in de omringende kaart; de link View item in de popup heeft geen kaart, dus de app nam de eerste
         tegel onder Still available en zette daar de strook RESERVED op, terwijl dat een ander, beschikbaar item is.
         Zonder <img> in de popup vindt de app daar niets. Het beeld is decoratief (alt was al leeg). */
      grid.querySelectorAll('[data-hv-bg]').forEach((d) => {
        d.style.backgroundImage = `url("${d.getAttribute('data-hv-bg').replace(/["\\\n]/g, encodeURIComponent)}")`;
        d.removeAttribute('data-hv-bg');
      });
      grid.hidden = items.length === 0;
      box.hidden = !info || (items.length === 0 && !info.collection);
      return info;
    });
  };

  const lock = () => html.classList.toggle('hv-pop-lock', !!document.querySelector('.hv-notify:not([hidden])'));

  /* Op een telefoon geen toetsenbord direct bij het openen: dat duwt het paneel weg. */
  const calmFocus = (dialog) => {
    const card = dialog.querySelector('.hv-notify__card');
    card.setAttribute('tabindex', '-1');
    setTimeout(() => {
      const a = document.activeElement;
      if (coarse.matches && a && a.classList && a.classList.contains('hv-notify__input')) {
        a.blur();
        card.focus({ preventScroll: true });
      } else if (!dialog.contains(document.activeElement)) {
        card.focus({ preventScroll: true });
      }
    }, 80);
  };

  /* ---------- Gereserveerd: popup van de app aankleden ---------- */

  const validEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((v || '').trim());

  /* De statusregel van de app in de huisstijl-tekst zetten (geen samentrekkingen). */
  const watchStatus = (card) => {
    const status = card.querySelector('.hv-notify__status');
    if (!status || status.__hvWatched) return;
    status.__hvWatched = true;
    const fix = () => {
      const t = status.textContent;
      if (!t) return;
      const input = card.querySelector('.hv-notify__input');
      const want = status.classList.contains('hv-notify__status--ok') ? L.thanks : input && !validEmail(input.value) ? L.error_email : L.error;
      if (t !== want) status.textContent = want;
    };
    new MutationObserver(fix).observe(status, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  };

  const dressReserved = (dialog) => {
    const card = dialog.querySelector('.hv-notify__card');
    if (!card) return;
    const close = card.querySelector('.hv-notify__close');
    if (close && !close.querySelector('svg')) {
      close.innerHTML = closeIcon;
      if (!close.getAttribute('aria-label')) close.setAttribute('aria-label', L.close);
    }
    const title = card.querySelector('.hv-notify__title');
    if (title && title.textContent !== L.reserved) title.textContent = L.reserved;
    const label = card.querySelector('.hv-notify__label');
    let heading = card.querySelector('.hv-pop__heading');
    if (!heading) {
      heading = document.createElement('p');
      heading.className = 'hv-pop__heading';
      heading.id = 'hv-pop-reserved-heading';
      heading.textContent = L.reserved_heading;
      if (label) label.after(heading);
      else card.insertBefore(heading, close ? close.nextSibling : card.firstChild);
      dialog.setAttribute('aria-labelledby', heading.id);
    }
    // Eigen tekst in de taal van de winkel in plaats van de tekst van de app (die "stuk" zei en naar het e-mailveld verwees).
    // De app blijft zijn eigen tekst bijwerken; die staat verborgen, de onze staat er direct onder.
    const appText = card.querySelector('.hv-notify__text');
    if (appText && L.reserved_text) {
      appText.style.display = 'none';
      if (!card.querySelector('.hv-pop__rtext')) {
        const own = document.createElement('p');
        own.className = 'hv-notify__text hv-pop__rtext';
        own.textContent = L.reserved_text;
        appText.after(own);
      }
    }
    const old = card.querySelector('.hv-pop__slot');
    if (old) old.remove();
    let box = card.querySelector('.hv-pop__similar');
    if (!box) {
      const tmp = document.createElement('div');
      tmp.innerHTML = similarHtml;
      box = tmp.firstChild;
      const text = card.querySelector('.hv-notify__text');
      const form = card.querySelector('.hv-notify__form');
      if (form) card.insertBefore(box, form);
      else if (text) text.after(box);
      else card.appendChild(box);
    }
    const input = card.querySelector('.hv-notify__input');
    if (input) {
      input.setAttribute('placeholder', L.placeholder);
      input.setAttribute('aria-label', L.placeholder);
    }
    const submit = card.querySelector('.hv-notify__submit');
    if (submit && submit.textContent !== L.submit) submit.textContent = L.submit;
    const view = card.querySelector('.hv-notify__view');
    if (view) view.textContent = L.view;
    watchStatus(card);
    const handle = (view && !view.hidden && handleFrom(view.getAttribute('href'))) || lastHandle || C.handle;
    loadSimilar(box, handle);
    calmFocus(dialog);
  };

  const watchDialog = (dialog) => {
    if (dialog.__hvWatched) return;
    dialog.__hvWatched = true;
    new MutationObserver(() => {
      lock();
      if (!dialog.hidden && !dialog.classList.contains('hv-notify--sold')) dressReserved(dialog);
    }).observe(dialog, { attributes: true, attributeFilter: ['hidden'] });
    if (!dialog.hidden && !dialog.classList.contains('hv-notify--sold')) dressReserved(dialog);
    lock();
  };
  document.querySelectorAll('.hv-notify').forEach(watchDialog);
  new MutationObserver((records) => {
    for (const r of records) {
      r.addedNodes.forEach((n) => {
        if (n.nodeType === 1 && n.classList.contains('hv-notify')) watchDialog(n);
      });
    }
  }).observe(document.body, { childList: true });

  /* ---------- Verkocht: eigen popup ---------- */

  const ensureSold = () => {
    if (sold) return sold;
    sold = document.createElement('div');
    sold.className = 'hv-notify hv-notify--sold';
    sold.hidden = true;
    sold.setAttribute('role', 'dialog');
    sold.setAttribute('aria-modal', 'true');
    sold.setAttribute('aria-labelledby', 'hv-pop-sold-heading');
    sold.innerHTML =
      '<div class="hv-notify__card">' +
      `<button type="button" class="hv-notify__close" aria-label="${esc(L.close)}">${closeIcon}</button>` +
      `<p class="hv-notify__label">${esc(L.sold)}</p>` +
      `<p class="hv-pop__heading" id="hv-pop-sold-heading">${esc(L.sold_heading)}</p>` +
      `<p class="hv-notify__text">${esc(L.sold_text)}</p>` +
      similarHtml +
      '<form class="hv-notify__form" novalidate>' +
      `<input class="hv-notify__input" type="email" name="email" required autocomplete="email" inputmode="email" placeholder="${esc(L.placeholder)}" aria-label="${esc(L.placeholder)}">` +
      `<button type="submit" class="hv-notify__submit">${esc(L.submit)}</button>` +
      '</form>' +
      `<p class="hv-pop__consent">${esc(L.consent)}</p>` +
      '<p class="hv-notify__status" role="status"></p>' +
      `<a class="hv-notify__view" hidden>${esc(L.view)}</a>` +
      '</div>';
    sold.querySelector('.hv-notify__close').addEventListener('click', closeSold);
    sold.addEventListener('click', (e) => {
      if (e.target === sold) closeSold();
    });
    sold.querySelector('.hv-notify__form').addEventListener('submit', (e) => {
      e.preventDefault();
      void submitSold();
    });
    document.body.appendChild(sold);
    watchDialog(sold);
    return sold;
  };

  function closeSold() {
    if (sold) sold.hidden = true;
    soldInfo = null;
  }

  const openSold = (handle, fromCard) => {
    const el = ensureSold();
    const similar = el.querySelector('.hv-pop__similar');
    const view = el.querySelector('.hv-notify__view');
    const status = el.querySelector('.hv-notify__status');
    const input = el.querySelector('.hv-notify__input');
    soldInfo = null;
    status.textContent = '';
    status.className = 'hv-notify__status';
    el.querySelector('.hv-notify__submit').disabled = false;
    try {
      input.value = localStorage.getItem('hv-notify-email') || '';
    } catch (e) {
      input.value = '';
    }
    view.hidden = !fromCard;
    view.setAttribute('href', `${root}products/${encodeURIComponent(handle)}`);
    el.hidden = false;
    calmFocus(el);
    loadSimilar(similar, handle).then((info) => {
      if (!info || el.hidden || similar.dataset.handle !== handle) return;
      soldInfo = info;
      if (info.url) view.setAttribute('href', info.url);
    });
  };

  const klaviyo = (path, body) =>
    fetch(`https://a.klaviyo.com/client/${path}/?company_id=${encodeURIComponent(C.companyId)}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify(body),
    });

  async function submitSold() {
    if (!sold) return;
    const input = sold.querySelector('.hv-notify__input');
    const submit = sold.querySelector('.hv-notify__submit');
    const status = sold.querySelector('.hv-notify__status');
    const email = (input.value || '').trim();
    if (!validEmail(email)) {
      status.className = 'hv-notify__status';
      status.textContent = L.error_email;
      input.focus();
      return;
    }
    submit.disabled = true;
    const info = soldInfo || {};
    const profile = { data: { type: 'profile', attributes: { email } } };
    try {
      const sub = await klaviyo('subscriptions', {
        data: {
          type: 'subscription',
          attributes: { custom_source: 'Sold item popup', profile },
          relationships: { list: { data: { type: 'list', id: C.listId } } },
        },
      });
      if (!sub.ok) throw new Error(`subscription ${sub.status}`);
      klaviyo('events', {
        data: {
          type: 'event',
          attributes: {
            properties: {
              brand: info.vendor || '',
              product_type: info.type || '',
              product_title: info.title || '',
              product_handle: info.handle || '',
              size: info.size || '',
              collection_url: info.collection ? info.collection.url : '',
              collection_title: info.collection ? info.collection.title : '',
            },
            metric: { data: { type: 'metric', attributes: { name: 'Sold item interest' } } },
            profile,
          },
        },
      }).catch(() => {});
      try {
        localStorage.setItem('hv-notify-email', email);
      } catch (e) {
        /* privémodus */
      }
      status.className = 'hv-notify__status hv-notify__status--ok';
      status.textContent = L.thanks;
    } catch (err) {
      console.warn('[hv-item-popup]', err);
      status.className = 'hv-notify__status';
      status.textContent = L.error;
      submit.disabled = false;
    }
  }

  /* ---------- Klikken ---------- */

  const hit = (el, x, y) => {
    const r = el.getBoundingClientRect();
    return r.width > 0 && x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
  };
  const soldButtons = () =>
    Array.from(document.querySelectorAll("product-form-component .add-to-cart-button[disabled], [class*='ai-sticky-button-'][disabled]")).filter(
      (b) => !b.closest('product-card, .product-card, quick-add-component, .quick-add-modal, dialog')
    );

  if (C.soldPdp) html.classList.add('hv-sold-pdp');

  /* Vooraf ophalen, zodat de popup bij de tik al gevuld is. */
  window.addEventListener(
    'pointerdown',
    (e) => {
      const card = cardOf(e.target);
      if (card && isSoldCard(card)) getInfo(cardHandle(card));
      else if (C.soldPdp) getInfo(C.handle);
    },
    { capture: true, passive: true }
  );

  window.addEventListener(
    'click',
    (e) => {
      const t = e.target;
      if (!t || !t.closest || t.closest('.hv-notify')) return;
      const card = cardOf(t);
      if (card) lastHandle = cardHandle(card);
      else if (t.closest('form[action*="/cart/add"]')) {
        const pfc = t.closest('product-form-component[data-product-url]');
        lastHandle = (pfc && handleFrom(pfc.dataset.productUrl)) || C.handle;
      } else lastHandle = C.handle;

      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

      if (card && isSoldCard(card) && !t.closest('.slideshow-control, select, input, label, [role="tab"]')) {
        const h = cardHandle(card);
        if (!h) return;
        e.preventDefault();
        e.stopPropagation();
        openSold(h, true);
        return;
      }
      if (C.soldPdp && C.handle && soldButtons().some((b) => hit(b, e.clientX, e.clientY))) {
        e.preventDefault();
        e.stopPropagation();
        openSold(C.handle, false);
      }
    },
    true
  );

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const open = document.querySelector('.hv-notify:not([hidden])');
    const close = open && open.querySelector('.hv-notify__close');
    if (close) close.click();
  });
})();
